<!-- blue box -->

<div class="header-section">
  <div class="header-line1">
    <a (click)="gotoPrevious()">
      <img class="login-close-button" id="close-button" [src]="constants.BACK_BUTTON" alt="close-button" />
    </a>
    <img [src]="constants.WS_GIFT" class="gift-img" />
    <span *ngIf="!isLogin" class="empty-profile"></span>
    <app-user-menu *ngIf="isLogin" [from]="from"></app-user-menu>
  </div>
  <div class="header-line-2">
    <span class="tab" [ngClass]="{ 'active': currentSection == 'details' }" *ngIf="!isLogin"><span
        class="circle">1</span>{{constants.GIFT_CHECKOUT_SECTIONS.SECTION1}}</span>
    <span class="tab" [ngClass]="{ 'active': currentSection == 'personalise' }"><span class="circle"><span
          *ngIf="!isLogin">2</span><span
          *ngIf="isLogin">1</span></span>{{constants.GIFT_CHECKOUT_SECTIONS.SECTION2}}</span>
    <span class="tab" [ngClass]="{ 'active': currentSection == 'billing' }"><span class="circle"><span
          *ngIf="!isLogin">3</span><span
          *ngIf="isLogin">2</span></span>{{constants.GIFT_CHECKOUT_SECTIONS.SECTION3}}</span>
  </div>
</div>
<!-- blue box ends -->
<div class="box-raised">
  <!-- Your Details Section Starts -->
  <div class="signin" *ngIf="currentSection == 'details'">
    <div *ngIf="login && !confirmCode">
      <div class="signin-header"><span class="create-account">{{constants.GIFT_LOGIN_TXT}}</span>
        <span (click)="takeToSignup()" class="already-account">{{constants.NO_ACCOUNT}}<strong
            class="cur-poin">{{constants.CREATE_ONE_HERE}}</strong></span>
        <span class="" class="already-account-mb"
          (click)="takeToSignup()"><strong>{{constants.CREATE_ACCOUNT}}</strong></span>
      </div>
      <form class='login-email-form' [formGroup]="signinForm" (ngSubmit)="onClicklogin()">
        <span id="errorAlert"></span>
        <span id="resend">{{constants.USER_IS_NOT_CONFIRMED}}<button [disabled]="isLoading" class='resend'
            (click)='onClickResend()'>{{constants.RESEND_VERI_CODE}}</button></span>
        <span class="input-text-required"
          *ngIf="signinForm.get('email').errors?.required && (signinForm.get('email').dirty || signinForm.get('email').touched)">
          {{constants.ENTER_EMAIL_ID}}<br></span>
        <span class="input-text-required" *ngIf="signinForm.get('email').errors?.email">
          {{constants.INVALID_EMAIL_ID}} </span>
        <input type="email" class="input-text animate__animated animate__fadeInUp" placeholder="Your Email Address"
          formControlName="email">
        <span class="input-text-required"
          *ngIf="signinForm.get('password').errors?.required && (signinForm.get('password').dirty || signinForm.get('password').touched)">
          {{constants.PASSWORD}} </span>
        <div class="password-container animate__animated animate__fadeInUp">
          <input class="input-text " id="input-password" type="password" placeholder="Password"
            formControlName="password">
          <i (click)="onClickSowPassowrd()" class="fa fa-eye password-show"></i>
        </div>
        <button [disabled]="isProcessing || !signinForm.valid" type="submit"
          class="forgot-passowrd-button animate__animated animate__fadeInUp">
          <span *ngIf="isProcessing" class="spinner-border spinner-border-sm mr-10" role="status"
            aria-hidden="true"></span>
          <span>{{constants.LOGIN_TXT}}</span> </button>
        <a class="forgot-passowrd animate__animated animate__fadeInUp"
          (click)="onClickForgot()">{{constants.FORGOT_PASSWORD}}</a>
      </form>
      <div>
        <p class="signin-text animate__animated animate__fadeInUp">{{constants.OR_TXT}}</p>
        <button id="text-box-2" type="button"
          class="btn btn-lg login-button animate__animated animate__fadeInUp mb-200"
          (click)="onLoginClick('Google')"><img class="google-img" [src]="constants.LOGIN_GOOGLE_IMG"
            alt="">&nbsp;&nbsp;&nbsp;&nbsp;
          {{constants.LOGIN_WITH_GOOGLE_TXT}}
        </button>
      </div>
    </div>
    <div class="container-fluid reset-form-container" *ngIf="!login && !confirmCode">
      <p class="logo animate__animated animate__fadeInUp">{{constants.WINDOW_SWAP_TXT}}</p>
      <p class="logo-sub-head animate__animated animate__fadeInUp">{{constants.ENTER_EMAIL_TXT}}</p>
      <form [formGroup]="resendForm" class="reset-form">
        <span id="errorAlert"></span>
        <span class="input-text-required"
          *ngIf="resendForm.get('email').errors?.required && (resendForm.get('email').dirty || resendForm.get('email').touched)">
          {{constants.ENTER_EMAIL_ID}}<br></span>
        <span class="input-text-required" *ngIf="resendForm.get('email').errors?.email">
          {{constants.INVALID_ID}}</span>
        <input type="email" class="input-text animate__animated animate__fadeInUp" placeholder="Your Email Address"
          formControlName="email">
        <button [disabled]="isProcessing || !resendForm.valid"
          class="login-email-button animate__animated animate__fadeInUp mb-200" (click)="onClickVerify()">
          <span *ngIf="isProcessing" class="spinner-border spinner-border-sm mr-10" role="status"
            aria-hidden="true"></span>{{constants.VERIFY_TXT}}</button>
      </form>
    </div>
    <div class="container-fluid reset-form-container" *ngIf="!login && confirmCode">
      <p class="logo animate__animated animate__fadeInUp">{{constants.WINDOW_SWAP_TXT}}</p>
      <p class="logo-sub-head animate__animated animate__fadeInUp">{{constants.ENTER_VERIFICATION_CODE}}</p>
      <form [formGroup]="confirmResendForm" class="reset-form">
        <span id="errorAlert"></span>
        <input [attr.disabled]='true' type="email" class="input-text animate__animated animate__fadeInUp"
          formControlName="email">
        <span class="input-text-required"
          *ngIf="confirmResendForm.get('code').errors?.required && (confirmResendForm.get('code').dirty || confirmResendForm.get('code').touched)">
          {{constants.PLEASE_ENTER_VERIFICATION_CODE}} </span>
        <input type="text" class="input-text animate__animated animate__fadeInUp" placeholder="Verification code"
          formControlName="code" autocomplete="code">
        <span class="input-text-required"
          *ngIf="confirmResendForm.get('password').errors?.required && (confirmResendForm.get('password').dirty || confirmResendForm.get('password').touched)">
          {{constants.PASSWORD}} </span>
        <span class="input-text-required" *ngIf="confirmResendForm.get('password').errors?.pattern">
          {{constants.STRONG_PASSWORD}}</span>
        <div class="password-container animate__animated animate__fadeInUp">
          <input class="input-text " id="input-password" type="password" placeholder="New password"
            formControlName="password" autocomplete="new-password">
          <i (click)="onClickSowPassowrd()" class="fa fa-eye password-show"></i>
        </div>
        <button [disabled]="isProcessing || !confirmResendForm.valid"
          class="login-email-button animate__animated animate__fadeInUp  mb-200" (click)="onClickConfirmSubmit()">
          <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{constants.SUBMIT}} </button>
      </form>
    </div>
  </div>
  <!-- Your Details Ends -->
  <!-- Personalise Section Starts -->
  <div class="personalise" *ngIf="currentSection == 'personalise'">
    <form [formGroup]="giftForm" (ngSubmit)="goToNext()">
      <div class="mb-15">
        <label for="receipientEmail" class="create-account"><span *ngIf="!alreadyHasSubscription">{{constants.WHO_IS_THIS_GIFT_FOR}}</span><span *ngIf="alreadyHasSubscription" class="already-account-prime">{{constants.ALREADY_HAS_SUBSCRIPTION}}</span></label>
        <div class="email-container">
        <input type="email" class="input-text" id="receipientEmail" spellcheck="false"
          placeholder="Recipient's email address" formControlName="receipientEmail" [ngClass]="{'border-blue': verified}">
          <span *ngIf="verified" class="verified-icon"><div class="verified-container"><img class="tick-icon" [src]="constants.TICK"/></div></span>
        </div>
        <div
          *ngIf="giftForm.controls['receipientEmail'].invalid && (giftForm.controls['receipientEmail'].touched || giftForm.controls['receipientEmail'].dirty)">
          <small *ngIf="giftForm.controls['receipientEmail'].hasError('required')"
            class="validation">{{constants.EMAIL_IS_REQUIRED}}</small>
          <small *ngIf="giftForm.controls['receipientEmail'].hasError('invalidEmail')"
            class="validation">{{constants.INVALID_ID}}</small>
        </div>
      </div>
      <button *ngIf="!verified" [disabled]="isProcessing || giftForm.controls['receipientEmail'].invalid"
        (click)="checkReceiverEmail()" class="not-verified-next" [ngClass]="{'not-verified-next-enabled': isProcessing}">
        <span *ngIf="isProcessing">{{constants.CHECKING_EMAIL}}</span><span
          *ngIf="isProcessing" class="white-spinner"></span><span *ngIf="!isProcessing">{{constants.NEXT}}</span></button>
      <ng-container *ngIf="verified">
        <div class="mb-15">
          <label for="receipientName"
            class="create-account">{{constants.RECEIPIENT_NAME}}</label>
          <input type="text" class="input-text" id="receipientName"
            placeholder="Full Name" formControlName="receipientName">
          <div
            *ngIf="giftForm.controls['receipientName'].invalid && (giftForm.controls['receipientName'].touched || giftForm.controls['receipientName'].dirty)">
            <small *ngIf="giftForm.controls['receipientName'].hasError('required')"
              class="validation">{{constants.RECEIPIENT_NAME_REQUIRED}}</small>
            <small *ngIf="giftForm.controls['receipientName'].hasError('maxlength')"
              class="validation">{{constants.MAX_LENGTH_100}}</small>
          </div>
        </div>
        <div class="mb-15">
          <label for="senderName"
            class="create-account">{{constants.WHO_THIS_GIFT_FROM}}</label>
          <input type="text" class="input-text" id="senderName" placeholder="Name"
            formControlName="senderName">
          <div
            *ngIf="giftForm.controls['senderName'].invalid && (giftForm.controls['senderName'].touched || giftForm.controls['senderName'].dirty)">
            <small *ngIf="giftForm.controls['senderName'].hasError('required')"
              class="validation">{{constants.SENDER_NAME_REQUIRED}}</small>
            <small *ngIf="giftForm.controls['senderName'].hasError('maxlength')"
              class="validation">{{constants.MAX_LENGTH_100}}</small>
          </div>
        </div>
        <div class="mb-15">
          <div class="d-flex flex-column">
            <label for="deliveryDate" class="create-account">
              {{constants.GIFT_DELIVERY_DATE}}
            </label>
            <div class="d-flex">
              <input type="date" class="input-date" id="deliveryDate"
                placeholder="dd/mm/yyyy" formControlName="deliveryDate" [min]="minDate" [max]="maxDate"
                #deliveryDateInput (click)="openCalendar()" />
            </div>
          </div>
          <div
            *ngIf="giftForm.controls['deliveryDate'].invalid && (giftForm.controls['deliveryDate'].touched || giftForm.controls['deliveryDate'].dirty)">
            <small *ngIf="giftForm.controls['deliveryDate'].hasError('required')"
              class="validation">{{constants.DELIVERY_DATE_REQUIRED}}</small>
            <small *ngIf="giftForm.controls['deliveryDate'].hasError('invalidDate')" class="validation">Select a date
              between {{minDate}} and {{maxDate}}</small>
          </div>
        </div>
        <div class="mb-15">
          <label for="message" class="create-account">
            {{constants.MESSAGE}}<br />
            <span class="message-hint">{{constants.MESSAGE_TEXT}}</span>
          </label>
          <textarea id="message" class="input-text-1" placeholder="Your message here"
            rows="4" spellcheck="false" formControlName="message"></textarea>
          <div *ngIf="giftForm.controls['message'] as messageControl">
            <div *ngIf="messageControl.invalid && (messageControl.touched || messageControl.dirty)">
              <small *ngIf="messageControl.hasError('required')"
                class="validation">{{constants.MESSAGE_REQUIRED}}</small>
              <small *ngIf="messageControl.hasError('maxlength')"
                class="validation">{{constants.MAX_LENGTH_500}}</small>
            </div>
          </div>
        </div>
        <button *ngIf="verified" [disabled]="!giftForm.valid" type="submit"
          class="verified-next">{{constants.NEXT}}</button>
      </ng-container>
    </form>
  </div>
  <!-- Personalise Section Ends -->
  <!-- Billing Section starts -->
  <div class="billing" *ngIf="currentSection == 'billing'">
    <div class="billing-wrapper">
      <div class="billing-info">
        <span class="billing-head-text"><strong>{{constants.ONE_TIME_CHARGE}}.</strong></span>
        <span class="billing-desc-text">Your gift will be sent on {{this.giftForm.get('deliveryDate').value | date: 'dd/MM/yyyy'}} and will provide the recipient with a 1-year All Access pass to WindowSwap.</span>
      </div>
      <img class="cards-img" [src]="constants.CARDS_IMG" />
      <div>
        <ngx-stripe-card-group [formGroup]="stripeForm" [elementsOptions]="elementsOptions">
          <div class="d-flex">
            <input type="text" formControlName="name" class="col name-input" placeholder="Name on card" spellcheck="false"
              (focus)="foundError = false" />
          </div>
          <div class="card-number">
            <ngx-stripe-card-number [options]="cardOptions" (focus)="foundError = false"></ngx-stripe-card-number>
          </div>
          <div class="card-details">
            <div class="card-expiry">
              <ngx-stripe-card-expiry [options]="cardOptions" (focus)="foundError = false"></ngx-stripe-card-expiry>
            </div>
            <div class="card-cvc">
              <ngx-stripe-card-cvc [options]="cardOptions" (focus)="foundError = false"></ngx-stripe-card-cvc>
            </div>
          </div>

          <button [disabled]="isLoading || stripeForm.invalid" id="btn" type="submit" (click)="createToken()" class="pay-btn" value="20">
            <mat-spinner *ngIf="isLoading" strokeWidth="3" [diameter]="20" class="text-center">
              {{constants.LOADING_TEXT}}
            </mat-spinner>
            <span *ngIf="!isLoading" id="USD"><b>{{constants.PAY_USD_50}}</b></span>
          </button>
        </ngx-stripe-card-group>
        <p *ngIf="foundError" class="error" id="error">{{errorMessage}}</p>
      </div>
    </div>
  </div>
  <!-- Billing Section ends -->
  <!-- Footer Section -->
  <footer class="footer-section" [ngClass]="{ 'mt-60': currentSection === 'billing' }">
    <a [href]="constants.INSTAGRAM_LINK" target="_blank" class="footer-link"><img [src]="constants.WS_INSTA_GIFTING"
        class="instagram" /></a>
    <a [routerLink]="['/blog']" target="_blank" class="footer-link"><img [src]="constants.WS_NEWS_GIFTING"
        class="latest-news" /></a>
    <a href="https://windowswapblog.squarespace.com/contact" target="_blank" class="footer-link"><img
        [src]="constants.WS_CONTACT_GIFTING" class="contact" /></a>
    <a [href]="constants.TERMS_CONDITIONS_LINK" class="footer-link"><img [src]="constants.WS_TERMS_GIFTING"
        class="terms" /></a>
  </footer>
</div>